module.exports = __webpack_public_path__ + "static/turtle-creek-house22-a8285369e22ac082fa60cd531dec30e9.jpg";